<template>
  <div class="app-container index-container">
    <!-- <div class="order-id" v-for="(item, index) in list" :key="index" >
      <span> {{ item.name }}</span>
      <span @click="fz(item)" data-clipboard-text="item.name">复制</span>
    </div> -->
    <div class="top-container flex-between">
      <div class="left-container">
        <keepAlive>
          <component :is="curr" />
        </keepAlive>
      </div>

      <div class="news-wrap">
        <div class="search-wrap">
          <el-input
            v-model.trim="searchVal"
            class="search-input"
            type="text"
            autocomplete="off"
            placeholder="请输入公告标题"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="clickSearchBtn"
            ></i>
          </el-input>
        </div>

        <!-- <div v-infinite-scroll="loadMoreMessage" class="message-wrap" :infinite-scroll-distance="600" :infinite-scroll-immediate="false"> -->
        <el-scrollbar class="message-content">
          <ul class="message-inner">
            <li
              v-for="item in messageList"
              :key="item.appMessagePk"
              class="news-item"
              :style="`border-left: 6px solid ${item.appMessageStatus === 'O' ? '#aeaeae' : (item.tagColor || '#F8F8F8')}`"
              @click="clickMessage(item)"
            >
              <div class="left-info">
                <div class="time">
                  <span :style="`color: ${item.appMessageStatus === 'O' ? '#aeaeae' : (item.tagColor || '#F8F8F8')}`">{{ item.tagName }}</span>
                  <span>{{ item.duration }}</span>
                </div>
                <p class="report-name txt_cut_2" :style="`color: ${item.appMessageStatus === 'O' ? '#aeaeae' : ''}`">
                  {{ item.appMessageTitle }}
                </p>
              </div>
            </li>

            <li v-show="!total" class="empty-wrap">
              <img src="../../assets/img/icon-empty.png" class="empty" alt="">
              <p class="empty-txt">暂无数据</p>
            </li>
          </ul>
        </el-scrollbar>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import first from './components/index'
import report from './components/report'
import info from './components/info'

import { formatTime } from '@/helpers/tool'
import { getToken } from '@/helpers/auth'
import Clipboard from 'clipboard'

export default {
  name: 'Index',
  components: { first, report, info },
  data() {
    return {
      loadingComponent: null,
      isLoading: false,
      total: 0,
      currPage: 1,
      limit: 50,
      messageList: [],
      searchVal: '',
      formatTime: formatTime,
      pcTriggerUpScroll: false,
      oldOffsetBottom: 0,
      noMore: false,
      curr: 'first',
      list: [
        {
          name: '内容1'
        }
        // {
        //   name: "内容2",
        // },
        // {
        //   name: "内容3",
        // },
      ]
    }
  },
  computed: {
    accountInfo() {
      return this.$store.getters.accountInfo
    },
    currCustomer() {
      return this.$store.getters.currCustomer
    },
    currDcpRoles() {
      return this.$store.getters.currDcpRoles
    },
    agreements() {
      return this.$store.getters.agreements
    }
  },
  watch: {
    isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: '',
          spinner: 'cricle_loader',
          background: 'rgba(255, 255, 255, 0)'
        })
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close()
        }
      }
    },
    $route(to, from) {
      this.curr = to.query.type
    }
  },
  mounted() {
    const _this = this
    let { query } = this.$route
    if (!query.type) {
      query = { ...{ type: 'first' }}
      this.$router.replace({ path: '/index', query })
    }
    this.curr = query.type || 'first'

    this.fetchMessage()

    this.$nextTick(() => {
      const scrollBox = document.querySelector('.el-scrollbar__wrap')
      scrollBox.addEventListener('scroll', function() {
        const messageOffsetBottom =
          scrollBox.scrollHeight - scrollBox.scrollTop - scrollBox.offsetHeight
        const direction = messageOffsetBottom - _this.oldOffsetBottom
        _this.oldOffsetBottom = messageOffsetBottom
        // console.log(messageOffsetBottom, _this.oldOffsetBottom, _this.pcTriggerUpScroll, direction, _this.noMore)
        if (
          messageOffsetBottom < 600 &&
          _this.pcTriggerUpScroll &&
          direction < 0 &&
          !_this.noMore
        ) {
          _this.currPage++
          _this.fetchMessage()
        }
      })
    })
  },
  methods: {
    fz(text) {
      var clipboard = new Clipboard('.order-id') // 绑定数据标签的类名
      clipboard.on('success', e => {
        console.log('复制成功')
        //  释放内存
        clipboard.destory()
      })
      clipboard.on('error', e => {
        // 不支持复制
        console.log('该浏览器不支持复制')
        // 释放内存
        clipboard.destory()
      })
    },
    dataTracking(tmp) {
      this.$api.login.dataTracking(tmp).then(res => {

      }).catch(err => {
        console.log(err)
      })
    },
    clickMessage(item) {
      this.gtag('event', 'usr_click_message', {
        value: item.appMessageCode
      })
      this.gtag('event', `usr_click_message_${item.appMessageCode}`)
      const tmp = {
        eventName: 'view_webpage',
        targetType: 'MESSAGE',
        targetPk: item.appMessagePk,
        agentType: 'PC',
        params: item.appMessageCode,
        uuid: this.accountInfo.accountUuid,
        customerNumber: this.currCustomer.customerNumber,
        roleCode: this.currDcpRoles[0].roleCode
      }
      this.dataTracking(tmp)

      this.$router.push({
        path: '/bannerDetail',
        query: {
          targetType: 'MESSAGE',
          targetPk: item.appMessagePk,
          agentType: 'PC',
          params: item.appMessageCode,
          uuid: this.accountInfo.accountUuid,
          customerNumber: this.currCustomer.customerNumber,
          roleCode: this.currDcpRoles[0].roleCode,
          hasWatermark: item.watermarkFlag,
          watermarkText: this.accountInfo.accountId
        }
      })
    },
    fetchMessage() {
      this.pcTriggerUpScroll = false
      this.noMore = false
      if (this.currPage <= 1) {
        this.messageList = []
      }

      const data = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          programType: this.currCustomer.programType,
          roleCode: this.currDcpRoles[0].roleCode,
          customerNumber: this.currCustomer.customerNumber,
          appMessageTitle: this.searchVal
        }
      }
      this.isLoading = true
      this.$api.message
        .getMessageList(data)
        .then((res) => {
          this.isLoading = false
          const list = res.data.items
          this.total = res.data.totalCount

          if (this.currPage <= 1) {
            this.messageList = list
          } else {
            this.messageList = this.messageList.concat(list)
          }

          if (this.messageList.length >= this.total) this.noMore = true

          // const arr = []
          // for (let i = 0; i < 50; i++) {
          //   arr.push({
          //     appMessageCode: 'TP20200101',
          //     appMessagePageUrl: 'https://azrcnedcceacsa01.z4.web.core.chinacloudapi.cn/dcc/message/TP20200101.html',
          //     appMessagePk: i,
          //     appMessageTitle: 'OCT折扣报告查询通知',
          //     duration: '17小时前',
          //     publishTime: '2020-12-21 19:50:08'
          //   })
          // }
          // this.messageList = [...arr]

          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            this.pcTriggerUpScroll = true
          })
        })
        .catch(() => {
          this.pcTriggerUpScroll = true
          this.isLoading = false
        })
    },
    clickSearchBtn() {
      console.log('clickSearchBtn')
      if (this.searchVal) {
        const tmp = {
          eventName: 'search',
          targetType: 'MESSAGE',
          targetPk: -1,
          agentType: 'PC',
          params: this.searchVal,
          uuid: this.accountInfo.accountUuid,
          customerNumber: this.currCustomer.customerNumber,
          roleCode: this.currDcpRoles[0].roleCode
        }
        this.dataTracking(tmp)
      }
      this.currPage = 1
      this.fetchMessage()
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-wrap {
  width: 100% !important;
  text-align: center;

  .empty {
    width: auto;
    height: 120px;
    margin: 30px auto 0;
  }

  .empty-txt {
    margin-top: 8px;
    font-size: 14px;
    color: #c0c4cc;
  }
}

.top-container {
  padding-top: 130px;
  padding-bottom: 100px;
}

.left-container {
  width: 766px;
}

/deep/ .el-scrollbar__wrap {
  box-sizing: border-box;
  height: calc(100vh - 80px - 48px - 100px - 70px);
  min-height: calc(600px - 70px);
  // padding-right: 16px;
  margin-bottom: 0 !important;
  overflow-x: hidden;
}

.news-wrap {
  position: fixed;
  top: 130px;
  left: calc((100vw - 766px - 384px - 40px) / 2 + 766px + 40px);
  width: 384px;
  // height: 266px;
  height: calc(100vh - 80px - 48px - 100px);
  min-height: 600px;
  padding: 10px 0;
  // margin-right: 4px;
  // margin-left: 20px;
  border-radius: 4px;
  // overflow: auto;
  background: #fff;
  box-shadow: 0 1px 17px 0 rgba(0, 0, 0, 0.08);
  cursor: pointer;

  .message-inner {
    padding: 0 10px;
  }

  .news-item {
    position: relative;
    display: flex;
    justify-content: space-between;
    height: 86px;
    padding: 0 10px;
    box-sizing: border-box;
    border-radius: 6px;
    box-shadow: 0px 5px 5px 0px #E9E9E9;

    + .news-item {
      margin-top: 14px;
    }

    .left-info {
      margin-top: 30px;
      flex-grow: 1;
      width: 0;

      .report-name {
        position: relative;
        font-weight: 500;
        font-size: 16px;
      }

      .time {
        font-size: 13px;
        position: absolute;
        top: 0;
        margin-top: 8px;
        color: #aeaeae;
        width: 93%;
        display: flex;
        justify-content: space-between;
      }
    }

    .right-icon {
      width: 40px;
      font-size: 24px;
      text-align: right;

      @include color_page_primary("color");
    }
    background: #F8F8F8;
    // @include background_color_page_primary("bg-color-light");
  }

  .search-input {
    padding: 0 10px;
    margin-bottom: 10px;

    /deep/ .el-input__inner {
      padding-left: 10px;
      border: none;
      border-bottom: 1px solid #000;
      border-radius: 0;
    }

    /deep/ .el-icon-search {
      font-size: 18px;
    }
  }
}
</style>
